export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-50 to-background-100"></div>
      <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.07] pointer-events-none">
        <div className="absolute top-1/2 right-0 -translate-y-1/2 text-[28rem] text-foreground-950 select-none">
          <i className="ri-newspaper-line"></i>
        </div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-500/10 border border-primary-500/20 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm text-primary-400 font-medium whitespace-nowrap">
                实时更新 · 黑料网最新地址已同步
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              黑料官网
              <span className="block text-primary-400 text-xl md:text-2xl lg:text-3xl mt-2 font-semibold">
                一站式娱乐资讯聚合入口
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-xl lg:max-w-none">
              找入口不再难，最新地址一站直达
            </p>

            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
              黑料官网专注于提供51黑料官网、黑料官网入口及黑料网官网的便捷访问指引。
              我们实时追踪黑料网最新地址与黑料网永久地址，聚合黑料网首页链接，
              彻底解决用户找入口难的问题。平台同时整合娱乐圈爆料、网红八卦、社会热点等
              多维度的最新资讯，让每一位访问者都能快速获取最热的娱乐内容。
              当前热门话题覆盖明星八卦、直播翻车、综艺争议等多个领域，
              每日更新不停歇。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-accent-500 text-lg font-bold">500万+</span>
                <span className="text-xs text-foreground-500">月活用户</span>
              </div>
              <div className="w-px h-4 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-accent-500 text-lg font-bold">24小时</span>
                <span className="text-xs text-foreground-500">地址同步更新</span>
              </div>
              <div className="w-px h-4 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-accent-500 text-lg font-bold">10万+</span>
                <span className="text-xs text-foreground-500">累计爆料内容</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-md transition-all duration-200 cursor-pointer text-sm"
              >
                <i className="ri-fire-line w-5 h-5 flex items-center justify-center"></i>
                浏览热门话题
              </a>
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-background-100 hover:bg-background-200 border border-background-300/60 text-foreground-700 hover:text-foreground-950 font-medium px-6 py-3 rounded-md transition-all duration-200 cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line w-5 h-5 flex items-center justify-center"></i>
                探索专题索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden bg-background-100 border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20abstract%20digital%20media%20composition%20with%20crimson%20red%20and%20warm%20gold%20geometric%20accents%2C%20modern%20editorial%20news%20portal%20aesthetic%2C%20mysterious%20cinematic%20lighting%20on%20dark%20background%2C%20entertainment%20media%20visual%20with%20high%20contrast%20and%20elegant%20texture&width=700&height=500&seq=hero-main-visual&orientation=landscape"
                alt="黑料官网 - 娱乐资讯聚合入口主视觉"
                title="黑料官网主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}